const accordionLink = () => {
  const openAccordionForHash = (hash) => {
    if (!hash || !hash.startsWith('#')) {
      return;
    }

    const targetId = hash.slice(1);
    if (!targetId) {
      return;
    }

    const target = document.getElementById(targetId);
    if (!target) {
      return;
    }

    const accordion = target.closest('.wmnds-accordion');
    if (!accordion) {
      return;
    }

    const summaryWrapper = accordion.querySelector('.wmnds-accordion__summary-wrapper');
    if (!summaryWrapper) {
      return;
    }

    accordion.classList.add('wmnds-is--open');
    summaryWrapper.setAttribute('aria-expanded', 'true');

    window.setTimeout(() => {
      const topOffset = 24;
      const scrollTarget = summaryWrapper || target;
      const topPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - topOffset;
      window.scrollTo({
        top: topPosition,
        behavior: 'smooth',
      });
    }, 120);
  };

  if (window.location.hash) {
    openAccordionForHash(window.location.hash);
  }

  window.addEventListener('hashchange', () => {
    openAccordionForHash(window.location.hash);
  });
};

export default accordionLink;
